import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../auth/auth.service';
import { UserModel } from '../../model/user.model';
import { SuccessSnackbarComponent } from '../success-snackbar/success-snackbar.component';

@Component({
  selector: 'app-trainer-password-edit-dailog',
  templateUrl: './trainer-password-edit-dailog.component.html',
  styleUrls: ['./trainer-password-edit-dailog.component.css']
})
export class TrainerPasswordEditDailogComponent implements OnInit {

  errorMessage: string = '';
  isLoading: boolean = true;

  durationInSeconds = 1;

  selectedItem:UserModel;

  constructor(private fb: FormBuilder,private mApiService:AuthService,private _snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<TrainerPasswordEditDailogComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any) { }

    onNoClick(): void {
      this.dialogRef.close();
    }

  ngOnInit(): void {
    this.selectedItem = this.data;
  }

  
savePasswordReset()
{

   console.log( this.selectedItem);

        
          this.mApiService
          .resetSystemUserPassword(this.selectedItem)
          .subscribe(
           p=>{
             
              if(p)
              {
                this.dialogRef.close() ;

                this._snackBar.openFromComponent(SuccessSnackbarComponent, {
                  duration: this.durationInSeconds * 1000,
                });
                
                // this.varShowPasswordResetDialog=false;
              }
           
             
             },
           e => this.errorMessage = e,
           ()=>this.isLoading=false
         )
}

}
